/**
 * LayoutStore — manages private layout UI state.
 * Controls sidebar expand/collapse and mobile drawer behavior.
 */
import { Injectable, signal, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

const SIDEBAR_KEY = 'sidebar-expanded';

@Injectable({ providedIn: 'root' })
export class LayoutStore {
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  readonly isSidebarExpanded = signal<boolean>(this.loadSidebarState());
  readonly isMobileSidebarOpen = signal<boolean>(false);

  toggleSidebar(): void {
    const next = !this.isSidebarExpanded();
    this.isSidebarExpanded.set(next);
    if (this.isBrowser) localStorage.setItem(SIDEBAR_KEY, String(next));
  }

  openMobileSidebar(): void {
    this.isMobileSidebarOpen.set(true);
  }

  closeMobileSidebar(): void {
    this.isMobileSidebarOpen.set(false);
  }

  toggleMobileSidebar(): void {
    this.isMobileSidebarOpen.update(v => !v);
  }

  private loadSidebarState(): boolean {
    if (!this.isBrowser) return true;
    try {
      const saved = localStorage.getItem(SIDEBAR_KEY);
      if (saved === null) {
        return true;
      }

      return saved === 'true';
    } catch {
      return true;
    }
  }
}
